import Navigo from 'navigo'

import { Routes } from './routes'

import { Render } from './utils'

import { isLoggedIn, sendEvent } from '../utils'

import { Events, Strings } from '../constants'

const currentData = {
    match: null
}

function showLogin() {

    sendEvent(Events.SHOW_LOGIN, { message: Strings.ERROR_NEED_LOGIN })
}

function showRoute(hashString, done) {

    sendEvent(Events.ON_NAVIGATE, { hashString: hashString })

    done()
}

function createRouter() {

    const base = new Navigo(`${import.meta.env.BASE_URL}`, {
        hash: true
    })

    base.hooks({

        before: function(done, match) {

            const hashString = match.hashString || `/${match.url}`

            const unprotected = [ '/login' ]
                .find((protectedHashString) => protectedHashString === hashString)

            if (! unprotected) {

                isLoggedIn().then((isLoggedIn) => {

                    if (! isLoggedIn) {

                        showLogin()
                    }

                    showRoute(hashString, done)

                }).catch(() => {

                    showLogin()

                    showRoute(hashString, done)
                })

            } else {

                showRoute(hashString, done)
            }
        }
    })

    const router = Routes.reduce((router, route) => {

        return router.on(route.url, (match) => {

            currentData.match = match

            route.render(match, route.template)
        })

    }, base)

    router.notFound(() => {

        Render(null, Routes[0].template)
    })

    return router
}

export const router = createRouter()

export function currentMatch() {

    return currentData.match
}

export function matchWithUrl(url) {

    const { route: { path } } = currentMatch()

    return `/${path}` === url
}
